<template>
  <v-tooltip
    v-bind="{ [position]: true }"
     color="primary" style="position: absolute;z-index: 10000"
									>
    <template v-slot:activator="{ on, attrs }" >
      <!-- Wrap default slot as activator -->
      <span v-bind="attrs" v-on="on">
        <slot></slot>
      </span>
    </template>
    <span >{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    text: {
      type: String,
      required: true, // tooltip text
    },

    position: { type: String, default: 'bottom' }, // accepts: top, bottom, left, right
  },
};
</script>

<style scoped>
/* optional: ensure inline elements work correctly */
</style>
